import { useEffect } from 'react'
import { useQuery } from 'react-query'

import { postObjectsFilter } from 'shared/api'
import { ErrorMessage } from 'infrastructure/shared/types'
import { WorkflowmodelFilterResult } from 'workflowmodel/shared/interfaces'
import { FilterResponse } from 'shared/types'

const payload = {
  query: {
    $and: [
      {
        $and: [
          {
            'situation.des': {
              $gte: '40'
            },
            'steps.des': {
              $regex: 'data_container'
            }
          }
        ]
      },
      {
        $and: [
          {
            'situation.des': {
              $gte: '40'
            },
            'steps.des': {
              $regex: 'taskmodels'
            }
          }
        ]
      }
    ]
  },
  orderby: [],
  objectclass: 'UUID_Objectclass_Workflowmodel',
  pagination: {},
  visualization: 'classic-list'
}

const useWorkflowmodels = () => {
  const { data, refetch, error } = useQuery<
    FilterResponse<WorkflowmodelFilterResult>,
    ErrorMessage
  >(
    ['workflow-models', payload],
    () => {
      return postObjectsFilter(payload, true)
    },
    { enabled: false }
  )

  useEffect(() => {
    refetch()
  }, [])

  useEffect(() => {
    if (error) console.log('error', error.message)
  }, [error])

  return data?.data.objects || []
}

export default useWorkflowmodels
